import * as React from 'react';

import { compose, mapProps } from 'recompose';

import type { ActionContext } from 'js/lib/ActionContext';

import { Button } from '@coursera/cds-core';
import { AddIcon } from '@coursera/cds-icons';

import { redesignStaffManagement } from 'bundles/staff-management/src/utils/epic';

import _t from 'i18n!nls/staff-management';

import 'css!../__styles__/NoStaff';

import { actions } from '../store';
import withFluxibleContextAsProps from '../withFluxibleContextAsProps';

type PropsFromConnect = {
  onClick(): void;
};
const ADD_STAFF_BUTTON_E2E = 'btn-add-staff';
/**
 * Button for initiating the add staff flow.
 */
export const AddStaffButton = ({ onClick }: PropsFromConnect) => {
  return (
    <Button
      variant="primary"
      size="small"
      icon={redesignStaffManagement() ? undefined : <AddIcon />}
      iconPosition="before"
      data-e2e={ADD_STAFF_BUTTON_E2E}
      onClick={onClick}
    >
      {redesignStaffManagement() ? _t('Invite Staff') : _t('Add Staff')}
    </Button>
  );
};

export const mapToProps = ({ executeAction }: ActionContext) => {
  return {
    onClick: () => {
      executeAction(actions.addFlow.prompt, { show: true });
    },
  };
};

export default compose<PropsFromConnect, {}>(
  withFluxibleContextAsProps(),
  mapProps<PropsFromConnect, ActionContext>(mapToProps)
)(AddStaffButton);
